import React from 'react';
import S from './styles';
import aboutImage from '../../resources/mainImage.jpg';

export const About = () => (
  <S.Section>
    <S.Wrap>
      <S.ContentsWrap>
        <S.Title
          id='about'
          data-sal="slide-up"
          data-sal-delay="100"
          data-sal-duration="600"
          data-sal-easing="ease"
        >
          ABOUT
        </S.Title>
        <S.Contents
          data-sal="slide-up"
          data-sal-delay="300"
          data-sal-duration="600"
          data-sal-easing="ease"
        >
          let us: Go!는 iOS 개발에 관심있는 모두가 모여 개발 노하우와 다양한 경험 그리고 정보를 서로 공유하고 자유롭게 소통하는 iOS 커뮤니티입니다.
          <br /><br />
          천고마비의 계절 가을입니다. 예쁜 보름달에 애플페이가 한국에 오게 해달라고 소원도 빌고, 높은 하늘보며 고수를 꿈꾸고 계시겠죠?!
          <br />
          진짜 가을이 성큼 다가왔네요. `11월 05일 토요일` [let us: Go! 2022 가을]을 개최하고자 합니다.
        </S.Contents>
      </S.ContentsWrap>
      <S.Image
        src={aboutImage}
        alt='let us: Go! 2019 iOS 단체 사진'
        data-sal="slide-up"
        data-sal-delay="300"
        data-sal-duration="600"
        data-sal-easing="ease"
      />
    </S.Wrap>
  </S.Section>
)
